import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <div className="container-x section-pad text-center">
      <p className="text-sm font-semibold" style={{ color: "var(--icrack-magenta-deep)" }}>404</p>
      <h1 className="mt-2 font-display text-4xl font-bold">Page not found</h1>
      <p className="mt-2 text-slate-600">The page you were looking for doesn't exist.</p>
      <div className="mt-6"><Link to="/"><Button className="rounded-xl btn-primary-magenta">Back to home</Button></Link></div>
    </div>
  );
}
